import "./DealDiligence.css";

import { UploadLightIcon } from "../../../../../assets";
import {
  Button,
  CursorDataGrid,
  DataGridColumnDefinition,
  DataGridCursorDataLoadEventHandler,
} from "../../../../../widget";

interface DealDiligenceProps {
  dealDocumentsColumns: DataGridColumnDefinition[];
  dealDocumentsLoading: boolean;
  onDealDocGridChange: DataGridCursorDataLoadEventHandler;
  onUploadDocument: () => void;
  dealDocumentsRefreshToken: boolean;
}

const DealDiligence = ({
  dealDocumentsColumns,
  dealDocumentsLoading,
  onDealDocGridChange,
  onUploadDocument,
  dealDocumentsRefreshToken,
}: DealDiligenceProps): JSX.Element => {
  return (
    <div className="DealDiligenceBody">
      {/* KAN-9066: Hide activites card */}
      {/* <div className="DealDiligenceCard">
        <div className="DealDiligenceCardHeader">
          <h2>Activities</h2>
          <Button
            text="New activity"
            variant="primary"
            size="small"
            corners="rounded"
            icon={<RoundedPlusSignIcon />}
            iconPosition="left"
            className="DealDiligenceActionButton"
          />
        </div>
        <p className="body2Light">There are currently no activities associated with this deal.</p>
      </div> */}

      <div className="DealDiligenceCard">
        <div className="DealDiligenceCardHeader">
          <h2>Documents</h2>
          <Button
            text="Upload document"
            variant="primary"
            size="small"
            corners="rounded"
            icon={<UploadLightIcon />}
            iconPosition="left"
            className="DealDiligenceActionButton"
            onClick={onUploadDocument}
          />
        </div>
        <div className="DealDiligenceDataGrid">
          <CursorDataGrid
            key={dealDocumentsRefreshToken ? "deal-docs-refresh-1" : "deal-docs-refresh-0"}
            columns={dealDocumentsColumns}
            data={[]}
            clientSide={false}
            filterable
            showFilterToggle
            onChange={onDealDocGridChange}
            pageable
            showTotalCount={false}
            hasNoPadding
            hasBottomMargin={false}
            noDataMessage="There are currently no documents associated with this deal."
            dataIsLoading={dealDocumentsLoading}
            variant="seed"
            pagination={{ pageSize: 10 }}
          />
        </div>
      </div>
    </div>
  );
};

export default DealDiligence;
